module.exports = __webpack_public_path__ + "img/edward-g.-walker.1cf62c38.png";